import React from "react";
import style from "./OurProjects.module.css";
import { Title } from "../Title";
import { Button, Image } from "../../ui";
import { RouteNames } from "../../router";
import { SORTED_PORTFOLIO_LIST } from "../../common";

export const OurProjects = () => {
  return (
    <div className={style.ourProjectContainer}>
      <div className="container">
        <Title title="Our projects" />
        <div className={style.ourProjectList}>
          {SORTED_PORTFOLIO_LIST.slice(0, 3).map(
            ({ title, text, alt, img, id }) => (
              <Image
                key={id}
                title={title}
                text={text}
                alt={alt}
                img={img}
                id={id}
                width={408}
                height={306}
              />
            )
          )}
        </div>
        <Button text={"See all"} path={RouteNames.PORTFOLIO} />
      </div>
    </div>
  );
};
